import { Center, Spinner, Text, VStack } from "@chakra-ui/react"
import React, { useCallback, useState } from "react"
import { AllWorkShiftsQueryVariables, useAllWorkShiftsQuery } from "../../graphql"
import { WorkShiftsList } from "./WorkShiftsList"

export const AllWorkShifts: React.FC = () => {
	const [pagination, setPagination] = useState<AllWorkShiftsQueryVariables["pagination"]>({ limit: 20, page: 1 })

	const [{ data, fetching, error }] = useAllWorkShiftsQuery({
		variables: { pagination },
	})

	const nextPage = useCallback(() => {
		if (fetching) return

		if (data?.allWorkShifts.hasNextPage) {
			setPagination((prev) => ({
				...prev,
				page: (prev.page || 0) + 1,
			}))
		}
	}, [data, fetching])

	return (
		<VStack w="full" maxW="2xl" align="stretch">
			{fetching && !data?.allWorkShifts ? (
				<Center w="full" py="4">
					<VStack w="full" color="grayscale.label">
						<Text fontSize="sm">Loading work shifts</Text>
						<Spinner size="sm" />
					</VStack>
				</Center>
			) : error ? (
				<Center py="4">
					<Text fontSize="sm" fontWeight="semibold" color="error.500">
						{error.message.replace("[GraphQL] ", "")}
					</Text>
				</Center>
			) : data?.allWorkShifts.workShifts && data.allWorkShifts.workShifts.length ? (
				<VStack w="full" align="stretch">
					<Text>
						Showing {data.allWorkShifts.workShifts.length || 0} work shift
						{(data.allWorkShifts.workShifts.length || 0) > 1 ? "s" : ""}
					</Text>

					<WorkShiftsList workShifts={data.allWorkShifts.workShifts} loadMore={nextPage} />

					{fetching && (
						<Center w="full" py="4">
							<VStack w="full" color="grayscale.label">
								<Text fontSize="sm">Loading more work shifts</Text>
								<Spinner size="sm" />
							</VStack>
						</Center>
					)}
				</VStack>
			) : (
				<Center py="4">
					<Text fontSize="sm" fontWeight="semibold" color="error.500">
						Couldn&apos;t find any WorkShifts.
					</Text>
				</Center>
			)}
		</VStack>
	)
}
